import type { Template } from "plotly.js";
import darkTemplate from "./plotlyDarkTemplate.json";

/**
 * Plotly's own `plotly_dark`, vendored as data.
 *
 * plotly.js ships no named templates: `plots.js` reads `layout.template` only
 * when it's a plain object, so `template: "plotly_dark"` is a silent no-op in
 * the browser (plotly/plotly.js#6646). The themes live in plotly.py, where a
 * name just resolves to this object. The JSON is that resolved object, not an
 * approximation — regenerate it on a plotly bump:
 *
 *     cd product/ai/lambdas/generate_preview
 *     uv run python -c "import json, plotly.io as pio; \
 *       print(json.dumps(pio.templates['plotly_dark'].to_plotly_json(), \
 *       indent=2, sort_keys=True))" > <this dir>/plotlyDarkTemplate.json
 *
 * Generated from plotly.py 6.7.0. `figureTheme.render.test.ts` checks it against
 * the installed plotly.js, so a bad regeneration fails loudly.
 */
export const PLOTLY_DARK_TEMPLATE = darkTemplate as unknown as Template;
